<template lang="pug">
  .media_controller(v-show="show")
    v-container
      v-row(v-if="showDelete")
        .title
          | Confirm delete
          b.ml-1.red--text {{ selections[0].name }}
          | ?
        v-spacer
        v-btn.mr-4(
          small, color="info",
          @click="showDelete = false",
        ) Cancel
        v-btn(
          small, color="error",
          @click="$emit('delete', selections[0].id)",
        ) Yes, I'm sure
      v-row(v-else)
        v-chip.ma-2(
          v-for="media in selections",
          :key="'selection'+media.id",
          close,
          color='primary',
          label,
          text-color='white',
          @click:close="$emit('remove', media)",
        )
          v-icon(left) {{ media.is_video ? 'fas fa-video' : 'far fa-image' }}
          | {{ media.name }}

        v-spacer
        v-btn.mx-2(
          v-if="onlyOne",
          fab, dark, small, color='primary'
          @click="$emit('download', selections[0])",
        )
          v-icon(dark) fas fa-download
        v-btn.mx-2(
          v-if="onlyOne",
          fab, dark, small, color='primary'
          @click="$emit('edit', selections[0])",
        )
          v-icon(dark) fas fa-edit
        v-btn.mx-2(
          v-if="onlyOne",
          fab, dark, small, color='primary',
          @click="showDelete = true",
        )
          v-icon(dark) fas fa-trash-alt
        v-btn.mx-2(
          fab, dark, small, color='primary'
          @click="$emit('preview')",
        )
          v-icon(dark) far fa-eye
</template>

<script>
// watcher
export default {
  props: {
    selections: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      showDelete: false,
    };
  },

  watch: {
    selections() {
      this.showDelete = false;
    },
  },

  computed: {
    onlyOne() {
      return this.selections.length === 1;
    },

    show() {
      return this.selections.length > 0;
    },
  },
};
</script>
